import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";

import logo from "../../assets/images/Logo Full Blue 1.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="header">
      <div className="header-container">

        {/* Logo */}

        <Link
          to="/"
          className="logo-wrapper"
          onClick={closeMenu}
        >
          <img
            src={logo}
            alt="Finsall company logo"
            className="header-logo"
          />
        </Link>

        {/* Mobile Menu Button */}

        <button
          className="mobile-menu-btn"
          onClick={() => setIsOpen(!isOpen)}
        >
          ☰
        </button>


        {/* Navigation */}

        <nav
          className={`nav-menu ${
            isOpen ? "nav-open" : ""
          }`}
        >
          <NavLink
            to="/home"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link"
                : "nav-link"
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/how-it-works"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link"
                : "nav-link"
            }
          >
            How It Works
          </NavLink>

          <NavLink
            to="/intermediaries"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link"
                : "nav-link"
            }
          >
            Intermediaries
          </NavLink>

          <NavLink
            to="/about-us"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link"
                : "nav-link"
            }
          >
            About Us
          </NavLink>

          <NavLink
            to="/careers"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link"
                : "nav-link"
            }
          >
            Careers
          </NavLink>

          <NavLink
            to="/contact-us"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link"
                : "nav-link"
            }
          >
            Contact Us
          </NavLink>
        </nav>

      </div>
    </header>
  );
};

export default Header;